<template>
  <div class="record-history">
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="page-title">Bridge History</div>
        <el-button class="refresh-btn" icon="el-icon-refresh" @click="getList" :loading="loading">
          Refresh
        </el-button>
      </div>
      <div class="spaceLeft search-form">
        <search-select @valChange="valChange($event, 'token')" label="Token Type" :options="tokenOptions" />
        <search-select @valChange="valChange($event, 'status')" label="Status" :options="statusOptions" />
      </div>
    </div>
    <div class="common-card-main common-card is-border">
      <el-table class="common-table" :data="tableList" v-loading="loading">
        <el-table-column prop="sourcechainid" label="From" align="left">
          <template slot-scope="{ row }">
            <div class="chain-info">
              <img :src="getChainIcon(row.sourcechainid)" class="chain-icon" />
              <div class="chain-details">
                <div class="chain-name">{{ row.sourcechainid=='6666'?'Treasurenet':'Ethereum' }}</div>
                <div class="token-amount">
                  <big-number :number="row.transferAmount" />
                  <span class="token-symbol"> {{ getTokenName(row.token) }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="targetchainid" label="To" align="left">
          <template slot-scope="{ row }">
            <div class="chain-info">
              <img :src="getChainIcon(row.targetchainid)" class="chain-icon" />
              <div class="chain-details">
                <div class="chain-name">{{ row.targetchainid =='5570'?'Treasurenet':'Ethereum' }}</div>
                <div class="token-amount">
                  <big-number :number="row.transferAmount" />
                  <span class="token-symbol">{{ getTargetTokenSymbol(row.token) }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="transferAmount" label="Token" align="left">
          <template slot-scope="{ row }">
            <div class="token-info">
              <img :src="getTokenIcon(row.token)" class="token-icon" />
              <div class="amount-info">
                <!-- <big-number :number="row.transferAmount" /> -->
                <span class="token-symbol">{{ getTokenName(row.token) }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="timestamp" label="UTC Time" align="left">
          <template slot-scope="{ row }">
            {{ moment.utc(row.timestamp).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>

        <el-table-column prop="status" label="Status" align="left">
          <template slot-scope="{ row }">
            <div class="status-wrapper" style="display: flex;">
              <el-tag :type="getStatusType(row.status)" class="status-tag">
                <!-- <i class="iconfont" :class="getStatusIcon(row.status)"></i> -->
                <img style="width: 0.24rem;height: 0.24rem;" :src="getStatusImage(row.status)" class="status-icon" />
                {{ getStatusText(row.status) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Option" align="left">
          <template slot-scope="{ row }">
            <el-button v-if="Number(row.status) === 0" class="cancel-btn" size="small" @click="handleCancel(row)">
              Cancel Bridging
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination 
        :total.sync="total" 
        :page.sync="page" 
        :limit.sync="pageSize"
        @pagination="getList()" 
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/bridgeRequest";
import { TOKEN_CONFIG, TOKEN_PAIRS } from '@/config/tokens'

export default {
  name: 'RecordHistory',
  data() {
    return {
      loading: false,
      // Search conditions
      token: undefined,
      status: undefined,
      // Pagination parameters
      total: 0, 
      page: 1,
      pageSize: 10,
      // Table data
      tableList: [],
      tokenOptions: [
        { value: "UNIT", label: "UNIT" },
        { value: "WUNIT", label: "WUNIT" },
        { value: "TCASH", label: "TCash" },
        { value: "WTCASH", label: "WTCash" }
      ],
      statusOptions: [
        { value: "Passed", label: "Passed" },
        { value: "Failed", label: "Failed" },
        { value: "Canceled", label: "Canceled" },
        { value: "Ongoing", label: "Ongoing" }
      ]
    };
  },
  created() {
    this.getList();
  },
  computed: {
    currentAccount() {
      return this.$store.getters.metaMaskObj.account;
    },
  },
  methods: {
    valChange(data, prop) {
      this[prop] = data.value;
      // Reset pagination
      this.total = 0;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    async getList() {
      this.loading = true;
      if (!this.currentAccount) {
        // this.$message.error('Please connect to the network');
        this.loading = false;
        return;
      }
      
      try {
        const res = await request({
          url: '/api/crosschain/records',
          method: 'get',
          params: {
            pageSize: this.pageSize,
            page: this.page,
            token: this.token,
            status: this.status,
            account: this.currentAccount
          }
        });
        
        console.log('res', res);
        if (res.code === 0) {
          this.tableList = res.data.records;
          console.log(res.data.pagination.total);
          this.total = res.data.pagination.total;
        }
      } catch (error) {
        console.error('Failed to fetch records:', error);
      } finally {
        this.loading = false;
      }
    },
    getStatusIcon(status) {
      switch (Number(status)) {
        case 9:
          return 'trn-success';
        case 12:
        case 13:
          return 'trn-fail';
        default:
          return 'trn-ing';
      }
    },
    getStatusType(status) {
      switch (Number(status)) {
        case 9:
          return 'warning';
        case 12:
          return 'danger';
        case 13:
          return 'orange';
        default:
          return 'success';
      }
    },
    getStatusText(status) {
      switch (Number(status)) {
        case 9:
          return 'Passed';
        case 12:
          return 'Failed';
        case 13:
          return 'Canceled';
        default:
          return 'Ongoing';
      }
    },
    getStatusImage(status) {
      switch (Number(status)) {
        case 9:
          return require('@/assets/image/exchange/icon_table_pass.png');
        case 12:
          return require('@/assets/image/exchange/icon_table_fail.png');
        case 13:
          return require('@/assets/image/exchange/icon_table_cancel.png');
        default:
          return require('@/assets/image/exchange/icon_table_ongoing.png');
      }
    },
    async handleCancel(row) {
      try {
        await this.$confirm(
          `<div class="cancel-confirm-content">
            <div class="cancel-title">Please note:</div>
            <div class="cancel-desc">
              Cancellation may result in non-refundable Bridge fees.
            </div>
          </div>`,
          'Confirm Cancellation',
          {
            confirmButtonText: 'Confirm Cancellation',
            cancelButtonText: 'Continue Bridging',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            customClass: 'custom-message-box',
          }
        );
        
        this.loading = true;
        try {
          const res = await request({
            url: '/api/crosschain/rollback',
            method: 'post',
            data: {
              id: row.id
            }
          });
          
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: "Your cross-chain operation has been cancelled."
            });
          } else {
            console.log('res', res);
            if (res.code == -1) {
              this.$message({
                type: 'error',
                message: "Your cross-chain transaction is completed and cannot be cancelled.'"
              });
            } else {
              this.$message({
                type: 'error',
                message: res.msg || 'Cancel failed'
              });
            }
          }
        } catch (error) {
          console.error('Cancel bridging error:', error.code);
          let msg = 'Cancel failed, please try again later';
          if(error.code) {
            if(error.code.msg) {
              msg = error.code.msg;
            }
          }
          this.$message({
            type: 'error',
            message: msg
          });
        } finally {
          this.loading = false;
          this.getList();
        }
      } catch (error) {
        // 用户取消操作，不做处理
        // this.$message({
        //   type: 'info',
        //   message: 'Operation cancelled'
        // });
      }
    },
    getTokenIcon(symbol) {
      // 遍历所有网络查找token图标
      for (const network in TOKEN_CONFIG) {
        const token = TOKEN_CONFIG[network].tokens.find(t => t.symbol === symbol)
        if (token && token.icon) {
          return token.icon
        }
      }
      return ""
      // // If not found, return default icon
      // return require('@/assets/image/exchange/default-token.png')
    },
    getChainIcon(chainId) {
      // Return the corresponding icon based on chainId
      switch (chainId.toString()) {
        case process.env.VUE_APP_ETH_CHAINID:
          return require('@/assets/image/transfer/eth.png')
        case process.env.VUE_APP_TN_CHAINID:
          return require('@/assets/image/exchange/unit.png')
        default:
          return require('@/assets/image/exchange/unit.png') // Default icon
      }
    },
    getTargetTokenSymbol(token) {
      // Return the corresponding cross-chain token based on token
      return TOKEN_PAIRS[token].name
    },
    getTokenName(token) {
      return TOKEN_PAIRS[token].nameSelf
    }
  }
};
</script>

<style lang="scss">
.el-tag {
  padding: 0 0.12rem;
  height: 0.32rem;
  line-height: 0.3rem;
  border-radius: 0.04rem;
  min-width: 0.8rem;
  text-align: center;

  &.el-tag--success {
    background-color: rgba(0, 199, 131, 0.2);
    color: #00C783;
    border-color: transparent;
  }

  &.el-tag--danger {
    background-color: rgba(217, 46, 47, 0.1);
    color: #D92E2F;
    border-color: transparent;
  }

  &.el-tag--warning {
    background-color: rgba(49, 114, 253, 0.2);
    color: #3172FD;
    border-color: transparent;
  }

  &.el-tag--orange {
    background-color: rgba(255, 152, 0, 0.2);
    color: #FF9800;
    border-color: transparent;

    .iconfont {
      color: #FF9800;
    }
  }
}

.spaceBetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.24rem;
}

.spaceLeft {
  display: flex;
  align-items: center;
  gap: 0.16rem;
}

.search-form {
  display: flex;
  gap: 0.16rem;
}

.record-history {
  width: 100%;
  padding: 0 1.067rem;
  margin: 0 auto;
  box-sizing: border-box;
}

.page-title {
  font-family: Roboto-Medium, Roboto;
  font-size: 0.32rem;
  color: #FFFFFF;
  line-height: 0.41rem;
  text-align: left;
  font-weight: bold;
}

.cancel-btn {
  background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
  border-radius: 0.06rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  font-size: 0.18rem;
  color: #FFFFFF;
  border: none;
  padding: 0.08rem 0.16rem;

  &:hover,
  &:focus {
    background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
    color: #FFFFFF;
    border: none;
  }
}

.refresh-btn {
  background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
  border-radius: 0.06rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  font-size: 0.18rem;
  color: #FFFFFF;
  border: none;
  padding: 0.08rem 0.16rem;
  margin-left: 0.16rem;

  &:hover,
  &:focus {
    background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
    color: #FFFFFF;
    border: none;
    opacity: 0.9;
  }

  &.is-loading {
    opacity: 0.8;
  }

  .el-icon-refresh {
    margin-right: 0.08rem;
  }
}

.chain-info {
  display: flex;
  align-items: center;
  gap: 0.12rem;

  .chain-icon {
    width: 0.32rem;
    height: 0.32rem;
  }

  .chain-details {
    display: flex;
    flex-direction: column;
    gap: 0.04rem;

    .chain-name {
      font-size: 0.16rem;
      color: #FFFFFF;
      line-height: 0.24rem;
    }

    .token-amount {
      font-size: 0.14rem;
      color: #929DAD;
      line-height: 0.2rem;

      .token-symbol {
        margin-left: 0.04rem;
      }
    }
  }
}

.token-info {
  display: flex;
  align-items: center;
  // justify-content: flex-end;
  gap: 0.12rem;

  .token-icon {
    width: 0.32rem;
    height: 0.32rem;
  }

  .amount-info {
    display: flex;
    align-items: center;
    gap: 0.04rem;

    .token-symbol {
      color: #929DAD;
      font-size: 0.14rem;
    }
  }
}

.status-tag {
  display: flex;
  align-items: center;
  gap: 0.08rem;
  padding: 0 0.12rem;
  height: 0.32rem;
  line-height: 0.3rem;
  border-radius: 0.04rem;
  min-width: 0.8rem;

  .iconfont {
    font-size: 0.24rem;
  }

  &.el-tag--success {
    background-color: rgba(0, 199, 131, 0.2);
    color: #00C783;
    border-color: transparent;

    .iconfont {
      color: #00C783;
    }
  }

  &.el-tag--danger {
    background-color: rgba(146, 157, 173, 0.2);
    color: #929DAD;
    border-color: transparent;

    .iconfont {
      color: #929DAD;
    }
  }

  &.el-tag--warning {
    background-color: rgba(49, 114, 253, 0.2);
    color: #3172FD;
    border-color: transparent;

    .iconfont {
      color: #3172FD;
    }
  }
}

.custom-message-box {
  font-family: DMSans-Bold, DMSans;
  width: 7.59rem !important;

  .el-message-box__header {
    padding: 0.31rem 0.48rem !important;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.09);

    .el-message-box__title {
      font-size: 0.28rem;
      font-weight: 500;
      color: #1F1F1F;
    }
  }

  .el-message-box__content {
    padding: 0.48rem !important;
    min-height: 2rem;
    font-size: 0.24rem;
    color: #1F1F1F;

    .cancel-confirm-content {
      font-family: DMSans-Bold, DMSans;
      .cancel-title {
        font-size: 0.24rem;
        font-weight: 500;
        color: #1F1F1F;
        margin-bottom: 0.16rem;
      }

      .cancel-desc {
        font-size: 0.2rem;
        color: #6B6B6B;
        line-height: 1.5;
      }
    }
  }

  .el-message-box__btns {
    font-family: DMSans-Bold, DMSans;
    padding: 0.24rem 0.48rem;
    border-top: 0.01rem solid rgba(0, 0, 0, 0.09);

    .el-button {
      // padding: 0 0.48rem;
      // height: 0.48rem;
      font-size: 0.18rem;
      border-radius: 0.06rem;
      min-width: 2.2rem;

      &+.el-button {
        margin-left: 0.24rem;
      }
    }

    .el-button--default {
      background: #FFFFFF;
      border: 0.01rem solid #D9DDE3;
      color: #6B6B6B;
    }

    .el-button--primary {
      background: #225BFC;
      border-color: #225BFC;
      color: #FFFFFF;
    }
  }
}
</style>
